import { useEffect } from "react";
import { SITE_URL } from "@/lib/api";

/**
 * Updates document.title, meta description, canonical URL and Open Graph tags
 * on route change for SEO landing pages.
 */
export default function useSeo({ title, description, path = "/", image }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [, key, prop] = selector.match(/\[([^=]+)="([^"]+)"\]/) || [];
        if (key && prop) el.setAttribute(key, prop);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", `${SITE_URL}${path}`);
    if (image) setMeta('meta[property="og:image"]', "content", image);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);

    // canonical link
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", `${SITE_URL}${path}`);
  }, [title, description, path, image]);
}
